import z from "zod";

export const getSubstitutionPlanByIdSchema = z.object({
	substitutionPlanId: z.string(),
});

export type GetSubstitutionPlanByIdSchema = z.infer<typeof getSubstitutionPlanByIdSchema>;
